import { useQuery } from 'react-query'
import { useRecoilValue } from 'recoil'
import { userIdAtom } from '../state/state'
import { axiosInstance } from '../api/http'

export const useGroups = () => {
  const userId = useRecoilValue(userIdAtom)

  const storeKey = ['user', userId, 'groups']
  return useQuery(storeKey, axiosInstance.mobile.usersControllerGetUserGroups, {
    enabled: !!userId,
    retry: false,
    select: ({ data }) => data.payload,
  })
}
